"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(isMobileView, shape) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccTimePickerStyle = (0, _react.useMemo)(function () {
    var shapeProps = function shapeProps() {
      var borderRadius = shape === 'roundedRectangle' ? pxToRem(10) : pxToRem(25);
      return {
        borderRadius: borderRadius
      };
    };
    var ccTimePicker = (0, _css.css)(_objectSpread(_objectSpread({
      fontFamily: fontFamily,
      fontWeight: 'bold',
      display: 'inline-block',
      direction: 'rtl',
      padding: "".concat(pxToRem(4), " ").concat(pxToRem(8)),
      border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border)
    }, shapeProps()), {}, {
      '> span': {
        margin: pxToRem(5),
        marginInlineEnd: 0,
        '&:nth-child(2)': {
          marginInlineStart: pxToRem(3),
          marginInlineEnd: pxToRem(3),
          fontSize: pxToRem(14)
        }
      }
    }));

    // --- Mobile Only ---

    var ccTimePickerAnchorBtn = (0, _css.css)({
      width: 'inherit',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      gap: pxToRem(10)
    });
    var ccTimePickerScrollSelectorContainer = (0, _css.css)({
      fontFamily: fontFamily,
      direction: 'rtl',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      height: pxToRem(160),
      position: 'relative',
      fontSize: pxToRem(20)
    });
    var ccTimePickerScrollSelectorMask = (0, _css.css)({
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      '&::after': {
        content: '":"',
        fontSize: pxToRem(20),
        fontWeight: 700,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)'
      }
    });
    return isMobileView ? {
      ccTimePicker: ccTimePicker,
      ccTimePickerAnchorBtn: ccTimePickerAnchorBtn,
      ccTimePickerScrollSelectorContainer: ccTimePickerScrollSelectorContainer,
      ccTimePickerScrollSelectorMask: ccTimePickerScrollSelectorMask
    } : {
      ccTimePicker: ccTimePicker
    };
  }, [fontFamily, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, isMobileView, shape]);
  return {
    'cc-TimePicker': ccTimePickerStyle.ccTimePicker,
    'cc-TimePicker__anchor-btn': ccTimePickerStyle.ccTimePickerAnchorBtn,
    'cc-TimePicker__scroll-selector-container': ccTimePickerStyle.ccTimePickerScrollSelectorContainer,
    'cc-TimePicker__scroll-selector-mask': ccTimePickerStyle.ccTimePickerScrollSelectorMask
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;